import { enableProdMode, provideZonelessChangeDetection, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { CurrencyPipe, DatePipe, LocationStrategy, HashLocationStrategy, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BearerTokenInterceptor } from './app/interceptors/bearer-token-interceptor';
import { AuthenticationService } from './app/services/authentication/authentication.service';
import { LocalStoreManagerService } from './app/services/local-store-manager-service/local-store-manager.service';
import { CookieService } from 'ngx-cookie-service';
import { SharedModule } from './app/shared/shared.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(SharedModule, BrowserModule, AppRoutingModule, NgbModule, ReactiveFormsModule, FormsModule, NgOptimizedImage),
        provideZonelessChangeDetection(),
        CurrencyPipe,
        DatePipe,
        { provide: HTTP_INTERCEPTORS, useClass: BearerTokenInterceptor, multi: true },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        AuthenticationService,
        LocalStoreManagerService,
        CookieService,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
